import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { StorageService } from '../../services/common/storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { ApiService } from '../../services/api.service';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-forget-password',
  templateUrl: './confirm-forget-password.component.html',
  styleUrl: './confirm-forget-password.component.scss'
})
export class ConfirmForgetPasswordComponent {
 config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
  };
  verifyOtpForm: FormGroup;
  otp: any;
  email: string = '';
  remainagAttemps: number = 0;
  maskedEmail:string="";
  userType=0;
  constructor(
    public dialog: MatDialog,
    private storageService: StorageService,
    private formBuilder: FormBuilder,
    private router: Router,
    private commonService: CommonService,
    private apiService: ApiService,
    private apiUrl: ApiUrlHelper,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private route:ActivatedRoute,
    private translate: TranslateService
  ) {
    
    this.verifyOtpForm = this.formBuilder.group({ otp: ['',[Validators.required]] });
   
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    history.pushState(null, '', location.href);
    window.addEventListener('popstate', () => {
      window.location.href = '/login'; // Forces reload and redirects
    });
    
    this.email = this.storageService.getValue('email')
    if(!this.email){
      this.router.navigate(['/login'])
      return
    }
      
    this.remainagAttemps = this.storageService.getValue('RemaingCount') ?? 0;
    this.maskedEmail = this.maskEmail( this.email);
    
    this.getUserType()
   
  }

  getUserType()
  {
    const FormData = {
      Email: this.storageService.getValue('email'),
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.forgetPassword.getUserType;
    this.apiService
      .doPost(apiUrl, FormData)
      .pipe()
      .subscribe({
        next: (response) => {
          this.spinner.hide();
          if (response && response.Success) {
            this.userType = response.Data.UserType;
            this.storageService.setValue('userTypeId', this.userType.toString());
          } else {
            this.toaster.error(response.Message);
          }
        },
        error: (er) => {
          this.spinner.hide();
          console.error(er);
          this.toaster.error(er.Message);
        },
      });
  }
  onOtpChange(event: any) {
    this.otp = event;
  }

  onVerifyOtp(event: any) {
    const FormData = {
      otp: this.verifyOtpForm.controls['otp'].value.trim(),
      email: this.storageService.getValue('email'),
    };
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.forgetPassword.verifyOTP;
    this.apiService
      .doPost(apiUrl, FormData)
      .pipe()
      .subscribe({
        next: (response) => {
          this.spinner.hide();
          if (response && response.Success) {
            this.toaster.success(this.translate.instant(response.Message));
            let email =this.commonService.Encrypt(FormData.email);
            let userType =this.commonService.Encrypt(this.storageService.getValue('userTypeId'));
            this.router.navigate(['/reset-password'], {
              queryParams: { email: email, userType: userType },
            });
          } else {
            this.toaster.error(this.translate.instant(response.Message));
          }
        },
        error: (er) => {
          this.spinner.hide();
          console.error(er);
          this.toaster.error(er.Message);
        },
      });
  }
  maskEmail(email: string): string {
    let parts = email.split('@');
    if (parts.length === 2) {
      let maskedLocal = parts[0].substring(0, 5) + '...'; // Show first 5 chars
      return maskedLocal + '@' + parts[1]; // Keep domain visible
    }
    return email; // Return original if not valid
  }
  resendCode() {
    this.email = this.storageService.getValue('email');
    const FormData = { email: this.email };
    this.storageService.setValue('email', FormData.email);
    this.spinner.show();
      const apiUrl = this.apiUrl.apiUrl.forgetPassword.forgotPasswordByEmail;
      this.apiService.doPost(apiUrl, FormData).pipe().subscribe({
            next: (response) => {
              this.spinner.hide();
              if (response && response.Success) {
                this.toaster.success(this.translate.instant(response.Message));
               // this.router.navigate(['/confirm-forget-password']);
              } else {
                this.toaster.error(this.translate.instant(response.Message));
              }
            },
            error: (er) => {
              this.spinner.hide();
              console.error(er);
              this.toaster.error(er.Message);
            }
          });
  }

  onSignup(){
    this.router.navigate(['/signup']);
  }
}
